module.exports = __webpack_public_path__ + "img/b-green-s@2x.5d06fcdf.png";